import { Form } from "../.."

import type { FallbackProps } from "."

export const Fallback: React.FC<FallbackProps> = (props) => (
  <Form.Page
    loading
    id="fallback_form"
    aside={<Form.Aside items={props.asideItems} />}
    header={<Form.Header items={props.headerItems} />}
    footer={<Form.Footer cancelRedirect={props.listLink} />}
  >
    <div />
  </Form.Page>
)
